import React from 'react';
import { Card, CardBody, CardTitle, CardText } from 'reactstrap';

const officials = [
    {
        title: "कुलानुशासक",
        name: "डॉ. जगतनारायण",
        contact: "99960-41064",
        email: "jagatkuk@gmail.com",
        campus: "टीक परिसर – महर्षि वाल्मीकि संस्कृत विश्वविद्यालय, कुरुक्षेत्र मार्ग, कैथल (हरियाणा) – 136027"
    },
    {
        title: "शैक्षणिक अधिष्ठाता",
        name: "प्रो. संजय गोयल",
        email: "daa@mvsu.ac.in",
        campus: "टीक परिसर – महर्षि वाल्मीकि संस्कृत विश्वविद्यालय, कुरुक्षेत्र मार्ग, कैथल (हरियाणा) – 136027"
    },
    {
        title: "छात्र कल्याण अधिष्ठाता",
        name: "डॉ. जगतनारायण",
        contact: "99960-41064",
        email: "dsw@mvsu.ac.in",
        campus: "टीक परिसर – महर्षि वाल्मीकि संस्कृत विश्वविद्यालय, कुरुक्षेत्र मार्ग, कैथल (हरियाणा) – 136027"
    },
    {
        title: "महाविद्यालय अधिष्ठाता",
        name: "प्रो. संजय गोयल",
        contact: "01746-297260",
        email: "doc@mvsu.ac.in",
        campus: "अस्थाई परिसर - डॉ. भीम राव अम्बेड़कर राजकीय महाविद्यालय, जगदीशपुरा, कैथल (हरियाणा) – 136027"
    },
    {
        title: "मुख्य संरक्षक/वार्डन",
        name: "डॉ. रामानन्द मिश्र",
        contact: "73551-15414",
        email: "cwm@mvsu.ac.in, cwf@mvsu.ac.in",
        campus: "टीक परिसर – महर्षि वाल्मीकि संस्कृत विश्वविद्यालय, कुरुक्षेत्र मार्ग, कैथल (हरियाणा) – 136027"
    },
    {
        title: "वित्ताधिकारी",
        name: "श्री कृष्ण कुमार",
        contact: "079883-10076",
        email: "financeofficer@mvsu.ac.in",
        campus: "अस्थाई परिसर - डॉ. भीम राव अम्बेड़कर राजकीय महाविद्यालय, जगदीशपुरा, कैथल (हरियाणा) – 136027"
    },
    {
        title: "परीक्षा नियंत्रक",
        name: "प्रो. भाग सिंह बोदला",
        contact: "94661-74087",
        email: "coe@mvsu.ac.in",
        campus: "अस्थाई परिसर - डॉ. भीम राव अम्बेड़कर राजकीय महाविद्यालय, जगदीशपुरा, कैथल (हरियाणा) – 136027"
    },
    {
        title: "पुस्तकालयाध्यक्ष",
        name: "डॉ. कृष्ण चन्द्र पाण्डे",
        contact: "98103-73278",
        email: "library@mvsu.ac.in",
        campus: "टीक परिसर – महर्षि वाल्मीकि संस्कृत विश्वविद्यालय, कुरुक्षेत्र मार्ग, कैथल (हरियाणा) – 136027"
    },
    {
        title: "अधिष्ठाता/संकाय प्रमुख (साहित्य एवं संस्कृति संकाय)",
        name: "डॉ. जगत नारायण",
        contact: "99960-41064",
        email: "hodsahitya@mvsu.ac.in",
        campus: "टीक परिसर – महर्षि वाल्मीकि संस्कृत विश्वविद्यालय, कुरुक्षेत्र मार्ग, कैथल (हरियाणा) – 136027"
    }
];

const UniversityOfficials = () => {
    return (
        <div className="container mt-5 mb-5">
            <h2 className="text-center mb-4 fw-bold ">विश्वविद्यालय के अधिकारी</h2>
            {officials.map((official, index) => (
                <Card key={index} className="mb-4 shadow border-0 rounded-4">
                    <CardBody>
                        <CardTitle tag="h5" className="text-primary fw-bold">
                            {official.title}
                        </CardTitle>
                        <CardText className="fs-5">
                            <strong>{official.name}</strong><br />
                            {official.contact && (
                                <>
                                    <strong>संपर्क:</strong> {official.contact}<br />
                                </>
                            )}
                            {official.email && (
                                <>
                                    <strong>ई-मेल:</strong>{' '}
                                    {official.email.split(',').map((email, i) => (
                                        <span key={i}>
                                            <a href={`mailto:${email.trim()}`}>{email.trim()}</a>{' '}
                                        </span>
                                    ))}
                                    <br />
                                </>
                            )}
                            <strong>पता:</strong> {official.campus}
                        </CardText>
                    </CardBody>
                </Card>
            ))}
        </div>
    );
};

export default UniversityOfficials;
